// extracted by mini-css-extract-plugin
export var attachmentContainer = "_jk-0";
export var fileList = "_jk-2";
export var removeFileButton = "_jk-1";